<button
    class="modal-close-button"
    type="button"
    [aria-label]="'global.close' | translate"
    (click)="clicked.emit($event)"
>
    <stby-icon icon="close" class="modal-close-button__icon" />
</button>
